import React, { ReactNode, createContext, useContext, useState } from "react";

interface PauseTimeProviderProps {
  children: ReactNode;
}

interface PauseTimeProps {
  setContagem: React.Dispatch<React.SetStateAction<string>>
  contagem: string

}

const PauseTime = createContext<PauseTimeProps>({} as PauseTimeProps);

export const PauseTimeProvider = ({ children }: PauseTimeProviderProps) => {
  const [contagem, setContagem] = useState('00:00:00')

  return (
    <PauseTime.Provider value={{
      contagem, setContagem,
    }}>
      {children}
    </PauseTime.Provider>
  );
};

export const usePauseTime = () => useContext(PauseTime);


